import React from 'react';
import { StyleSheet, Text } from 'react-native';
import { FontAwesome } from '@expo/vector-icons';
import Style from '../../../../constants/Style';
import PressableStyled from '../../../PressableStyled';
import Colors from '../../../../constants/Colors';

interface DetailsButtonProps {
  onPress: () => void,
}

const DetailsButton = ({ onPress }: DetailsButtonProps) => <PressableStyled
  style={Style.row}
  {...{ onPress }}
>
  <Text style={styles.text}>{'Details'}</Text>
  <FontAwesome
    name='angle-right'
    size={16}
    color={styles.text.color}
  />
</PressableStyled>;

const styles = StyleSheet.create({
  text: {
    fontSize: 14,
    lineHeight: 22,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlue500,
    marginEnd: 4,
  },
});

export default DetailsButton;
